module.exports = __webpack_public_path__ + "static/media/manguera-verde.f0dc6c5c.svg";